import { useMemo } from 'react'
import useHiddenFormElements from './useHiddenFormElements'

const usePageErrorMessages = () => {
  const pageErrorMessageElements = useHiddenFormElements('.error.pageLevel')

  return useMemo(
    () =>
      pageErrorMessageElements
        .filter((e) => e?.style?.display !== 'none' && e?.ariaHidden !== 'true')
        .map((e) => e.innerText)
        .map((e) =>
          e.includes('UserMigration') || e.includes('{')
            ? 'Oops! There seems to be a problem with the login process. We are currently working on resolving it. Please try again later.'
            : e,
        )
        .join('<br/>'),
    [pageErrorMessageElements],
  )
}

export default usePageErrorMessages
